import React, { Component } from "react";

class InvalidHash extends Component {
    render() {
       return (
            <div className="invalidHash">
              <div className="wrap">
                <h1>Link inválido</h1>
                <p>O link que você acessou está incorreto. Verifique com seu gestor.</p>
              </div>
            </div>
        )
    }
}

export default InvalidHash;




// WEBPACK FOOTER //
// ./src/app/home/container/invalidHash.js